import { render } from "./Notification.vue?vue&type=template&id=6a9a516c"
import script from "./Notification.vue?vue&type=script&lang=js"
export * from "./Notification.vue?vue&type=script&lang=js"

import "./Notification.vue?vue&type=style&index=0&id=6a9a516c&lang=scss"

import exportComponent from "/app/tmp/origina/V3/v2026.33.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__